import Cotteges from './Cotteges';
export default Cotteges;



// WEBPACK FOOTER //
// ./src/components/Cotteges/index.js